var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup73(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.460938,
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62109 11.8807C9.62109 11.3035 9.8238 10.8273 10.2292 10.4522C10.6346 10.077 11.1616 9.8894 11.8103 9.8894C12.4474 9.8894 12.9628 10.0741 13.3566 10.4435C13.762 10.8245 13.9647 11.3208 13.9647 11.9327C13.9647 12.4868 13.7678 12.9486 13.374 13.318C12.9686 13.6989 12.4358 13.8894 11.7755 13.8894H11.7582C11.1211 13.8894 10.6057 13.6989 10.2118 13.318C9.818 12.937 9.62109 12.4579 9.62109 11.8807ZM9.84696 27.0323V15.4652H13.7041V27.0323H9.84696ZM15.8412 27.0323H19.6983V20.5734C19.6983 20.1693 19.7447 19.8576 19.8373 19.6383C19.9995 19.2458 20.2456 18.9139 20.5757 18.6426C20.9058 18.3714 21.3199 18.2357 21.818 18.2357C23.1153 18.2357 23.764 19.1073 23.764 20.8504V27.0323H27.6211V20.4002C27.6211 18.6917 27.2157 17.3959 26.4049 16.5128C25.5941 15.6297 24.5226 15.1881 23.1906 15.1881C21.6964 15.1881 20.5323 15.8288 19.6983 17.1102V17.1448H19.6809L19.6983 17.1102V15.4652H15.8412C15.8643 15.8346 15.8759 16.9832 15.8759 18.911C15.8759 20.8389 15.8643 23.546 15.8412 27.0323Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup73);
export default __webpack_public_path__ + "static/media/Group 73.296b4b86f7481582a4dbc7e8a0895fb3.svg";
export { ForwardRef as ReactComponent };